import { render, staticRenderFns } from "./SampleReview.vue?vue&type=template&id=260296c7&scoped=true&"
import script from "./SampleReview.vue?vue&type=script&lang=js&"
export * from "./SampleReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260296c7",
  null
  
)

export default component.exports